import React from "react";
import ReactECharts from "echarts-for-react";

const DemandChargesChart: React.FC = () => {
  const months = Array.from({ length: 12 }, (_, i) => {
    const date = new Date();
    date.setMonth(i);
    return date.toLocaleString("en-US", { month: "short" });
  });

  const randomData = Array.from({ length: 12 }, () => 500);

  const options = {
    tooltip: {
      trigger: "axis",
      backgroundColor: "#181B25",
      borderWidth: 0,
      textStyle: {
        color: "#fff",
        fontSize: 12,
      },
    },
    xAxis: {
      type: "category",
      data: months,
      axisLabel: {
        color: "#181B25",
        fontSize: 11,
        fontWeight: 400,
      },
    },
    yAxis: {
      type: "value",
      name: "Consumption",
      axisLabel: {
        formatter: "{value}",
        color: "#5F6368",
        fontSize: 9,
        fontWeight: 400,
        lineHeight: 11,
        letterSpacing: 0.2,
      },
      splitLine: {
        show: true,
        lineStyle: {
          color: "#e0e0e0",
          type: "dashed",
        },
      },
    },
    grid: {
      left: "5%",
      right: "7%",
      bottom: "3%",
      containLabel: true,
    },
    series: [
      {
        type: "bar",
        data: randomData,
        lineStyle: {
          color: "#1976d2",
          width: 2,
        },
        itemStyle: {
          color: "#1976d2",
        },
        symbol: "circle",
        symbolSize: 6,
      },
    ],
    toolbox: {
      feature: {
        saveAsImage: {},
        restore: {},
        dataView: {},
        magicType: { type: ["line", "bar"] },
        brush: { type: ["rect", "polygon", "clear"] },
        dataZoom: {},
      },
    },
  };

  return <ReactECharts option={options} />;
};

export default DemandChargesChart;
